import { PersonnelContext } from 'features/Responder/features/Personnel';
import { useContext, useState } from 'react';
import { RecipientPicker } from './RecipientPicker';

/**
 * Composer for creating new conversations (direct or group).
 * @param {{ onCreateConversation: (data: { type, participants, name? }) => void, isCreating: boolean, onCancel: () => void, error?: string }} props
 */
export function ConversationComposer({ onCreateConversation, isCreating, onCancel, error, currentUserId }) {
  const personnelContext = useContext(PersonnelContext);
  const personnel = personnelContext?.personnel || {};

  const [selectedRecipientIds, setSelectedRecipientIds] = useState([]);
  const [groupName, setGroupName] = useState('');
  const [validationError, setValidationError] = useState('');

  const handleToggleRecipient = (personId) => {
    setSelectedRecipientIds((prev) =>
      prev.includes(personId) ? prev.filter((id) => id !== personId) : [...prev, personId],
    );
    // Clear errors when selection changes
    setValidationError('');
  };

  const handleGroupNameChange = (e) => {
    setGroupName(e.target.value);
    // Clear errors when user types
    setValidationError('');
  };

  const handleCreate = () => {
    if (selectedRecipientIds.length === 0 || isCreating) return;

    const isGroup = selectedRecipientIds.length > 1;

    // Validate group name is required for groups
    if (isGroup && !groupName.trim()) {
      setValidationError('Group name is required');
      return;
    }

    const data = {
      type: isGroup ? 'group' : 'direct',
      participants: selectedRecipientIds,
    };

    if (isGroup) {
      data.name = groupName.trim();
    }

    onCreateConversation(data);
  };

  return (
    <>
      <RecipientPicker
        personnel={personnel}
        selectedIds={selectedRecipientIds}
        onToggleRecipient={handleToggleRecipient}
        currentUserId={currentUserId}
        onCancel={onCancel}
      />

      {selectedRecipientIds.length > 1 && (
        <div className="responder-messenger-group-name-field">
          <input
            className={`responder-messenger-input ${validationError || error ? 'error' : ''}`}
            type="text"
            placeholder="Group name (required) *"
            value={groupName}
            onChange={handleGroupNameChange}
            maxLength={100}
          />
          {(validationError || error) && (
            <div className="responder-messenger-error-message">{validationError || error}</div>
          )}
        </div>
      )}

      <button
        type="button"
        className="responder-messenger-primary-btn"
        disabled={selectedRecipientIds.length === 0 || isCreating}
        onClick={handleCreate}
      >
        {isCreating
          ? 'Creating...'
          : selectedRecipientIds.length > 1
            ? 'Create group chat'
            : 'Start message'}
      </button>
    </>
  );
}
